module.exports = __webpack_public_path__ + "img/project-01-01.ee6f7ef3.png";